export default __webpack_public_path__ + "static/media/Heroku.65afb279.md";